"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeSystem = void 0;
exports.IkeSystem = {
    /** IKE Office related system information */
    OFFICE: 'office',
    /** IKE field related systems, eg logging elastic indexes */
    FIELD: 'field',
};
//# sourceMappingURL=system.js.map